// invExport.js — CSV export of a count review / past run: one count column per user, plus a column that
// says how each person's quantity came about (Scanned / Added / Set).

const csvCell = (v) => {
    const t = v === null || v === undefined ? '' : String(v);
    return /[",\n]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
};

const methodText = (u) => [
    u.scanned > 0 ? `Scanned ${u.scanned}` : null,
    u.added   !== 0 ? `Added ${u.added}`   : null,
    u.set     !== 0 ? `Set ${u.set}`       : null,
].filter(Boolean).join(', ');

// lines: inv_lines rows; breakdown: /scans payload; beforeBySku: optional {sku: {before, after}} for applied runs
// opts.adding: Add Inventory, where the scanned quantity is added to what is on hand (no Picked / Effective)
export function exportReviewCsv(lines, breakdown, filename, beforeBySku = null, opts = {}) {
    const skus = breakdown?.skus || {};
    const users = [];
    let unattributed = false;
    Object.values(skus).forEach(b => {
        b.users.forEach(u => { if (!users.includes(u.user)) users.push(u.user); });
        if (b.adjustment !== 0) unattributed = true;
    });
    const head = opts.adding
        ? ['SKU', 'Adding', beforeBySku ? 'Before' : 'On hand now', beforeBySku ? 'After' : 'New total', ...users.map(u => `${u} count`)]
        : ['SKU', 'Counted', 'Picked', 'Effective',
            beforeBySku ? 'Before' : 'Was', beforeBySku ? 'After' : 'Delta', ...users.map(u => `${u} count`)];
    if (unattributed) head.push('Unattributed');
    head.push('Scanned / Added / Set');
    const rows = [head];
    lines.forEach(l => {
        const b = skus[l.sku] || { users: [], adjustment: 0 };
        const eff = (l.scanned || 0) + (l.picked_added || 0) + (l.overstock_counted || 0);
        const ba = beforeBySku?.[l.sku];
        const row = opts.adding
            ? [l.sku, l.scanned || 0,
                beforeBySku ? (ba ? ba.before : '') : (l.live_on_hand ?? ''),
                beforeBySku ? (ba ? ba.after : '') : (l.live_on_hand != null ? l.live_on_hand + (l.scanned || 0) : '')]
            : [l.sku, l.scanned || 0, l.picked_added || 0, eff,
                beforeBySku ? (ba ? ba.before : '') : (l.live_on_hand ?? ''),
                beforeBySku ? (ba ? ba.after : '') : (l.live_on_hand != null ? eff - l.live_on_hand : '')];
        users.forEach(name => {
            const u = b.users.find(x => x.user === name);
            row.push(u ? u.scanned + u.entered : '');
        });
        if (unattributed) row.push(b.adjustment || '');
        row.push(b.users.filter(u => methodText(u)).map(u => `${u.user}: ${methodText(u)}`).join('; '));
        rows.push(row);
    });
    const csv = rows.map(r => r.map(csvCell).join(',')).join('\r\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
}
